import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { getBorderRadiusOptions } from "@circle-react-shared/BuilderUI/utils/imgStyleHelpers";
import { getSizingOptions } from "@circle-react-shared/BuilderUI/utils/sizeStyleHelpers";
import { DesignProp, SizingProp } from "../../../constants/PropCategories";
import { getFontWeightOptions } from "../../../utils/textStyleHelpers";
import { createImageBlock } from "../../utils/mediaBlockHelpers";
import { createH6Block, createPBlock } from "../../utils/textBlocksHelpers";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "userCard",
  meta: {},
  props: {
    image: {
      meta: {
        name: "Image",
        nameI18n: "builder_ui.prop_type.image",
      },
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                width: "100%",
                height: "auto",
                minWidth: "48px",
                minHeight: "48px",
                maxWidth: "48px",
                maxHeight: "48px",
              },
              category: [DesignProp, SizingProp],
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    header: {
      meta: {
        name: "Header",
        nameI18n: "builder_ui.prop_type.header",
      },
      prop: "children",
      type: "children",
      value: [
        createH6Block({
          text: "Sarah Johnson",
          styles: {
            fontWeight: getFontWeightOptions("600"),
          },
        }),
      ],
    },
    description: {
      meta: {
        name: "Description",
        nameI18n: "builder_ui.prop_type.description",
      },
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: "CEO, TechVision Inc.",
        }),
      ],
    },
  },
};
